import { render, staticRenderFns } from "./japanIndex.vue?vue&type=template&id=208115c4&scoped=true&"
import script from "./japanIndex.vue?vue&type=script&lang=js&"
export * from "./japanIndex.vue?vue&type=script&lang=js&"
import style0 from "./japanIndex.vue?vue&type=style&index=0&id=208115c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208115c4",
  null
  
)

export default component.exports